// custom-help-dropdown.js -- created by Monica October 29

document.addEventListener('DOMContentLoaded', function () {
  // Select the help button
  const helpButton = document.querySelector('.head-help-button-toggle.dropdown-toggle')

  if (helpButton) {
    // Determine the dropdown menu associated with the button
    // Adjust the selector based on your actual dropdown structure
    const dropdownMenu = helpButton.nextElementSibling // Example for sibling

    if (dropdownMenu && dropdownMenu.classList.contains('dropdown-menu')) {
      // Prevent the dropdown from closing when clicking inside the dropdown menu
      dropdownMenu.addEventListener('click', function (event) {
        event.stopPropagation()
      })

      // Additionally, prevent the dropdown from closing when selecting text
      dropdownMenu.addEventListener('mousedown', function (event) {
        event.stopPropagation()
      })
    }
  }
})
